import { Div, Label, Loader, useWindowSize, useAlert } from "@grassrootly/rn-core";
import { IGroupMembers } from "@grassrootly/api";
import { Platform, ScrollView } from "react-native";
import React from "react";
import { GroupTabItemProps } from "../GroupTabs.types";
import { useGroupMembers } from "./useGroupMembers";
import SwipeablePlayerItem from "./SwipeablePlayerItem";
import useBaseRequest from "../../../../api/BaseRequest";
import { RemovePlayerFromGroup, MakePlayerAdmin } from "@grassrootly/api";

export default function GroupMembers({ group, navigation }: GroupTabItemProps) {
  const { loading, groupMembers, refetch } = useGroupMembers({ group });
  const { width } = useWindowSize();
  const { success, danger } = useAlert();

  const { loading: removingPlayer, execute: removePlayer } = useBaseRequest(RemovePlayerFromGroup, {
    onCompleted: () => {
      success({ message: "Player removed from group successfully" });
      refetch(); // Refresh the members list
    },
    onError: (error) => {
      danger({ message: error.message || "Failed to remove player from group" });
    },
  });

  const { loading: makingAdmin, execute: makeAdmin } = useBaseRequest(MakePlayerAdmin, {
    onCompleted: () => {
      success({ message: "Player promoted to admin successfully" });
      refetch(); // Refresh the members list
    },
    onError: (error) => {
      danger({ message: error.message || "Failed to make player admin" });
    },
  });

  const handleRemovePlayer = (playerId: number) => {
    if (!group?.id) return;
    removePlayer({
      groupId: group.id,
      playerId: playerId,
    });
  };

  const handleMakeAdmin = (playerId: number) => {
    if (!group?.id) return;
    makeAdmin({
      groupId: group.id,
      playerId: playerId,
    });
  };
  return (
    <Div classNames={["flex1"]}>
      {loading ? (
        <Div classNames={["mt-{30}"]}>
          <Loader size="large" isLoading />
        </Div>
      ) : null}

      {!loading && groupMembers && (!Array.isArray(groupMembers) || groupMembers.length === 0) ? (
        <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight", "mt-{30}"]}>
          Group Members not found
        </Label>
      ) : null}

      {!loading && groupMembers && (
        <ScrollView
          style={{ marginTop: -16 }}
          contentContainerStyle={{
            paddingTop: 24,
            paddingBottom:
              Platform.OS !== "web"
                ? (() => {
                    const arr = groupMembers ? Object.values(groupMembers as any) : [];
                    const len = Array.isArray(arr) ? arr.length : 0;
                    return len ? len * 20 : 20;
                  })()
                : 0,
          }}
          showsVerticalScrollIndicator={false}
        >
          <>
            {groupMembers
              ? (() => {
                  const arr = Object.values(groupMembers) as IGroupMembers[];
                  const sorted = arr
                    .slice()
                    .sort((a: any, b: any) => (b.points_earned ?? 0) - (a.points_earned ?? 0));
                  return sorted.map((item: IGroupMembers, index: number) => (
                    <SwipeablePlayerItem
                      key={`${item.player_id}-${index}`}
                      item={item}
                      index={index}
                      isAdmin={group?.is_owner || false}
                      onPress={() => navigation?.navigate("eqipa-card", { playerId: item.player_id })}
                      onRemove={() => handleRemovePlayer(item.player_id)}
                      onMakeAdmin={() => handleMakeAdmin(item.player_id)}
                    />
                  ));
                })()
              : null}
          </>
        </ScrollView>
      )}
    </Div>
  );
}
